import traceActionsCreator from '../traceActionsCreator'

// export const sampleAction = createAction('AppConfig/sample')

export const getAppVersionServiceName = 'AppConfig/getAppVersion'
export const getAppVersionTraceActions = traceActionsCreator(
  getAppVersionServiceName
)
